import { render, staticRenderFns } from "./AppR.vue?vue&type=template&id=cb1ec1d4&"
import script from "./AppR.vue?vue&type=script&lang=js&"
export * from "./AppR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports